function Ctrl($scope, $location, metaTagService) {
  metaTagService.set({
    title: 'Concierge Service | Tablelist',
    description: 'Contact the Tablelist Concierge to help plan your night, or answer questions about your booking.'
  });

  const suggestedMessage = $location.search().message;

  const sampleMessage = 'Hello Tablelist Concierge, my friends and I would like to go out this weekend - can you help me find a great package for us?';

  $scope.message = suggestedMessage || sampleMessage;
}

Ctrl.$inject = [
  '$scope',
  '$location',
  'metaTagService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/concierge/conciergeCtrl.js